export default __webpack_public_path__ + "static/media/character-size.a0ee618d.svg";